export default __webpack_public_path__ + "static/media/local.3e14269e.png";